export const FEATURE_FLAGS = {
  heic: {
    description: 'test heic image upload',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-41691',
  },
  'directory-pages': {
    description: 'Directory pages for countries, regions, cities, and species',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-50173',
  },
  'regulations-refactor': {
    description: 'Server-rendered regulations section showing top 3 species with app-download CTA',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-50906',
  },
  'state-hub-pages': {
    description: 'State sub pages (species, fishing waters, fishing reports)',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-52743',
  },
} as const;

// 'test' and 'test2' is needed for the unit tests - should not be used for actual feature flags.
export type FeatureFlag = keyof typeof FEATURE_FLAGS | 'test' | 'test2';
